import script from "./DoubleRange.vue?vue&type=script&setup=true&lang=js"
export * from "./DoubleRange.vue?vue&type=script&setup=true&lang=js"

import "./DoubleRange.vue?vue&type=style&index=0&id=5474caf7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5474caf7"]])

export default __exports__